// Copyright 2026. WebPros International GmbH. All rights reserved.

export const SET_USER_CREDENTIALS = 'auth/SET_USER_CREDENTIALS';
export const SET_IS_AUTH = 'auth/SET_IS_AUTH';
export const SET_USER = 'auth/SET_USER';
export const UPDATE_USER = 'auth/UPDATE_USER';
export const SET_USER_TWO_FACTOR_AUTH = 'auth/SET_USER_TWO_FACTOR_AUTH';
